<template>
  <div>
    <div @click="dialog = true" v-if="btn !== false">
      <slot />
    </div>
    <v-autocomplete
      :value="vehicle"
      :items="vehicles"
      :label="label"
      @change="changedTo"
      @click:clear="clear"
      :loading="selectLoading"
      :clearable="clearable"
      :rules="rules"
      :search-input.sync="filter"
      :disabled="disabled"
      autocomplete="off"
      :no-filter="true"
      :append-outer-icon="disabled === false ? 'mdi-magnify' : ''"
      @click:append-outer="
        showGrid1 = true;
        vehicleCreateDialog = true;
      "
      :prepend-icon="prependIcon"
      :prepend-inner-icon="prependInnerIcon"
      :multiple="multiple"
      v-if="btn === false"
    >
      <template v-slot:selection="data">
        <div ripple class="height32" v-if="multiple === false">
          <v-img
            :src="data.item.pic"
            height="20"
            width="24"
            style="float: left; margin-right: 10px"
          ></v-img>
          <div style="width: 90px; float: left; font-size: 14px">
            {{ data.item.regNo }}
          </div>
          <div style="min-width: 82px; float: left; font-size: 14px">
            {{ data.item.truckTypeStr }}
          </div>
        </div>
        <div ripple v-else>
          <div
            class="v-chip--select v-chip v-chip--clickable v-chip--no-color theme--light v-size--default"
          >
            <v-img
              :src="data.item.pic"
              height="20"
              width="24"
              style="float: left; margin-right: 10px"
            ></v-img>
            <div style="width: 90px; float: left; font-size: 14px">
              {{ data.item.regNo }}
            </div>
            <div style="min-width: 82px; float: left; font-size: 14px">
              {{ data.item.truckTypeStr }}
            </div>
          </div>
        </div>
      </template>
      <template v-slot:item="data" class="px-2">
        <v-list-item ripple class="px-0">
          <v-list-item-content class="px-0">
            <v-list-item-title class="px-0">
              <v-img
                :src="data.item.pic"
                height="20"
                width="24"
                style="float: left; margin-right: 10px"
              ></v-img>
              <div style="width: 90px; float: left; font-size: 12px">
                {{ data.item.regNo }}
              </div>
              <div style="min-width: 82px; float: left; font-size: 12px">
                {{ data.item.truckTypeStr }}
              </div>
              <v-icon small v-if="selected(data.item)" style="float: right"
                >mdi-check</v-icon
              >
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="mt-2"></v-divider>
      </template>
      <template v-slot:append-item>
        <div class="actionBox">
          <!-- <v-btn small text color="info" @click="vehicleCreateDialog = true">
            <v-icon>mdi-plus</v-icon>
            {{ $i18n.t("Add New Vehicle") }}
          </v-btn> -->
          <z-vehicle-create-form @select="select"
             ><v-btn small text >
              <v-icon>mdi-plus</v-icon>
              {{ $i18n.t("Add New Vehicle") }}
            </v-btn></z-vehicle-create-form
          >
        </div>
      </template>
    </v-autocomplete>

    <!-- <z-vehicle-create-form
      @select="select"
    ></z-vehicle-create-form> -->

    <z-vehicle-create
      @select="select"
      :bodyType="bodyType"
      :truckType="truckType"
      :showDialog="vehicleCreateDialog"
      :showGrid1="showGrid1"
    ></z-vehicle-create>
  </div>
</template>

<script>
import { doGet } from "@/store/common/module/apis";
import common from "@/store/common/module/common";
import Themeable from "vuetify/lib/mixins/themeable";
import { Vue, Component, Watch } from "vue-property-decorator";
import orderBy from "lodash/upperFirst";

@Component({
  name: "VehicleSelect",
  props: {
    corp_id: {
      default: null,
    },
    value: {
      default: null,
    },
    bodyType: {
      default: null,
    },
    truckType: {
      default: null,
    },
    idOnly: {
      default: false,
    },
    disabled: {
      default: false,
    },
    label: {
      default: "Vehicle",
    },
    multiple: {
      default: false,
    },
    clearable: {
      default: false,
    },
    btn: {
      default: false,
    },
    prependIcon: {
      default: undefined,
    },
    prependInnerIcon: {
      default: undefined,
    },
    rules: {
      default: () => [],
    },
  },
})
export default class VehicleSelect extends (Vue, Themeable) {
  rows = 20;
  showGrid1 = false;
  url = "/api/vehicle/grid?rows=";
  regNo = "";
  vehicleType = null;
  supplier = null;
  country = null;
  on = null;
  page = 1;
  dialog = false;
  vehicle = null;
  vehicles = [];
  filter = "";
  vehicleCreateDialog = false;
  filterUrl = "";
  selectLoading = false;

  async mounted() {
    await this.onValueChange(this.value);
  }

  get loading() {
    return this.selectLoading;
  }

  select(vehicle) {
    this.dialog = false;
    this.vehicleCreateDialog = false;
    if (vehicle) {
      this.vehicle = vehicle;
      this.vehicles = [vehicle];
      if (this.idOnly === false) {
        this.$emit("input", vehicle);
      } else {
        this.$emit("input", vehicle._id);
      }
    }
  }

  tableHeight() {
    return window.innerHeight - 400 + "px";
  }

  changedTo(newVal) {
    if (newVal) {
      if (this.multiple === false) {
        this.vehicle = newVal;
        if (this.idOnly === false) {
          this.$emit("input", newVal);
        } else {
          this.$emit("input", newVal._id);
        }
      } else {
        const response = [];
        for (let i = 0; i < newVal.length; i++) {
          response.push(newVal[i]._id);
        }
        this.$emit("input", response);
      }
    } else {
      // this.$emit("input", null);
      this.vehicles = [];
    }
    this.filter = "";
  }

  clear() {
    this.filter = "";
    this.vehicle = null;
    this.$emit("input", null);
  }

  @Watch("filter")
  async onFilterChange(val) {
    if (val != null && val.length > 1 && val.length < 20) {
      const filter = val.toLowerCase();
      this.selectLoading = true;
      const vehicles = await doGet(
        "/api/vehicle/autofill?key=" +
          filter +
          (this.corp_id ? "&corp_id=" + this.corp_id : "")
      );
      this.selectLoading = false;
      if (vehicles != null && vehicles.length > 0) {
        orderBy(vehicles, ["vehicleType", "regNo"], ["asc", "asc"]);
        this.vehicles = vehicles;
      } else {
        this.vehicles = [];
      }
      if (this.vehicles != null && this.vehicles.length > 0 && focus)
        this.show = true;
    }
  }

  @Watch("value")
  async onValueChange() {
    this.selectLoading = true;
    this.vehicle = null;
    if (this.idOnly === false) {
      if (this.value && !this.value.isAdhoc && this.value._id) {
        this.vehicle = await doGet(
          "/api/vehicle/" +
            (this.value._id ? this.value._id : "null") +
            "/limitedDetail?regNo=" +
            this.value.regNo
        );
        this.vehicles = [this.vehicle];
      } else if (this.value) {
        this.vehicle = this.value;
        this.vehicles = [this.value];
      }
    } else if (this.value) {
      if (!this.value.isAdhoc) {
        this.vehicle = await doGet(
          "/api/vehicle/" + this.value + "/limitedDetail"
        );
        this.vehicles = [this.vehicle];
      } else {
        this.vehicle = this.value;
        this.vehicles = [this.value];
      }
    }

    this.selectLoading = false;
  }

  selected(val) {
    if (val != null && val._id != null && this.value != null) {
      if (Array.isArray(this.value)) {
        return this.value.includes(val._id);
      } else if (this.value === val._id) {
        return true;
      }
    }
    return false;
  }
}
</script>

<style scoped>
.pac-target-input {
  width: 50%;
  border: 1px solid #dfdfdf;
  height: 30px;
  padding: 10px 20px;
  z-index: 1;
  background: white;
  margin-left: 25%;
  position: absolute;
  margin-top: 10px;
}
.v-dialog > .v-card > .v-card__text {
  padding-top: 5px;
  padding-bottom: 5px;
}
.v-card .v-card__actions {
  padding-top: 5px;
  padding-bottom: 5px;
}
.v-dialog .v-card .v-card__title {
  padding-top: 10px;
}
.actionBox {
  position: sticky;
  background: white;
  bottom: 0px;
  width: 100%;
  z-index: 1;
  height: 50px;
  border-top: 1px solid #dfdfdf;
  padding: 10px;
}
</style>
